<template>
  <th>{{ columnTotal }}</th>
</template>

<script>
export default {
  props: [
    'column',
    'values'
  ],
  computed: {
    columnTotal () {
      if (this.column.type_id !== 2) return ''

      return this.values.reduce((acc, value) => {
        return (this.isNumber(value.value.value)) ? parseInt(parseFloat(value.value.value) * 100) + acc : acc
      }, 0) / 100
    }
  },
  methods: {
    isNumber (val) {
      return val !== null && !isNaN(val)
    }
  }
}
</script>
